import React from 'react';
import EmployeeDashboard from '../components/EmployeeDashboard';

const EmployeePage = () => {
  return <EmployeeDashboard />;
};

export default EmployeePage;